"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2520],{

/***/ 68885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _useNormalizeAndMapFilters = _interopRequireDefault(__webpack_require__(39738));
var _default = _useNormalizeAndMapFilters["default"];
exports["default"] = _default;

/***/ }),

/***/ 39738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _useSelectState = __webpack_require__(88829);
var _useMultiSelectState = __webpack_require__(23851);
var _RangePicker = __webpack_require__(84633);
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var normalizeData = function normalizeData(item) {
  var ret = _objectSpread({}, item);
  if (ret.type === "select") {
    ret.value = (0, _useSelectState.normalizeSelectValue)(ret.options, ret.value, true);
  } else {
    ret.value = null; // TODO: do this
  }
  return ret;
};
var areEqual = function areEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
};
function getValuesObject(data) {
  var obj = {};
  data.forEach(function (item) {
    obj[item.id] = item.value;
  });
  return obj;
}
var normalizeFilterValue = function normalizeFilterValue(filter) {
  if (filter.type === "select") {
    return (0, _useSelectState.normalizeSelectValue)(filter.options, filter.value, true);
  } else if (filter.type === "multiselect") {
    return (0, _useMultiSelectState.normalizeMultiSelectValue)(filter.options, filter.value);
  } else if (filter.type === "range") {
    return (0, _RangePicker.normalizeRangePickerValue)(_objectSpread(_objectSpread({}, filter), {}, {
      fractionDigits: filter.id === "capacity" ? 3 : 2
    }), false);
  } else {
    return null;
  }
};

/**
 * TODO: don't run onChange when nothing changed (even if commit was run)
 */

// for now: enableReinitalize not available, we assume true.
function useNormalizeAndMapFilters(_ref) {
  var _data, _data2;
  var data = _ref.data,
    onChange = _ref.onChange,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var _useState = (0, _react.useState)(0),
    counter = _useState[0],
    setCounter = _useState[1];
  var localValues = (0, _react.useRef)({});
  var committedValues = (0, _react.useRef)({});
  var previousValues = (0, _react.useRef)({});
  var filterClear = (0, _react.useRef)({
    id: null,
    clear: false,
    clearAll: false
  });
  data = (_data = data) === null || _data === void 0 ? void 0 : _data.map(function (filter) {
    if ((filter === null || filter === void 0 ? void 0 : filter.id) === "capacity" && !filter.isConverted) {
      var _filter$value, _filter$value2;
      return _objectSpread(_objectSpread({}, filter), {}, {
        isConverted: true,
        max: filter.max / 1000,
        min: filter.min / 1000,
        value: filter.value && {
          from: ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.from) / 1000,
          to: ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.to) / 1000
        }
      });
    }
    return filter;
  });
  var values = {}; // normalized values based on current data
  (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.forEach(function (filter) {
    values[filter.id] = normalizeFilterValue(filter);
  });

  // UPDATE local values (makes sense if data changes and we have different filters structure)
  // Thanks to refs we can do this "right away", not on useEffect and cause re-render.

  for (var filterId in localValues.current) {
    // If new value for this filter from props is different from previous value from props (like value from server changed)
    if (!areEqual(values[filterId], previousValues.current[filterId])) {
      delete localValues.current[filterId];
      delete committedValues.current[filterId];
    }

    // If this filterId is not in the list anymore
    if (!values.hasOwnProperty(filterId)) {
      delete localValues.current[filterId];
      delete committedValues.current[filterId];
    }
  }
  previousValues.current = _objectSpread({}, values);
  var getDataWithCurrentValues = function getDataWithCurrentValues() {
    var _data3;
    return (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.map(function (item) {
      var value = localValues.current[item.id] === undefined ? values[item.id] : localValues.current[item.id]; // null means that it was set by clear
      var committedValue = committedValues.current[item.id] === undefined ? values[item.id] : committedValues.current[item.id];
      if (item.id === filterClear.current.id && filterClear.current.clear) {
        value = [];
        committedValue = [];
      }
      var nullValue = normalizeFilterValue(_objectSpread(_objectSpread({}, item), {}, {
        value: null
      }));
      var isDirty = !areEqual(value, committedValue);
      var isEmpty = areEqual(value, nullValue);
      var isCommittedEmpty = areEqual(committedValue, nullValue);
      value = isEmpty ? null : value;
      committedValue = isCommittedEmpty ? null : committedValue;
      return _objectSpread(_objectSpread({}, item), {}, {
        value: value,
        committedValue: committedValue,
        isDirty: isDirty,
        isEmpty: isEmpty,
        isCommittedEmpty: isCommittedEmpty
      });
    });
  };
  var setValue = function setValue(id, newValue) {
    var isSoft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var runOnChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    // normalize
    var emptyValue = newValue === null;
    var filter = data.find(function (x) {
      return x.id === id;
    });
    newValue = normalizeFilterValue(_objectSpread(_objectSpread({}, filter), {}, {
      value: newValue
    }));
    if (areEqual(newValue, localValues.current[id])) {
      // don't run onChange when requesting same change
      return;
    }
    if (emptyValue && !isMobile) {
      localValues.current[id] = null;
      delete localValues.current[id];
      delete committedValues.current[id];
      if (filter.value && onChange && runOnChange) {
        filterClear.current = _objectSpread(_objectSpread({}, filterClear.current), {}, {
          id: id,
          clear: emptyValue
        });
      } else {
        filterChangedWithNoCommittedValues = true;
      }
    } else if (!isSoft) {
      localValues.current[id] = newValue;
      committedValues.current[id] = newValue;
      filter.isDirty = false;
      var newData = getDataWithCurrentValues();
      if (onChange && runOnChange) {
        onChange(newData);
      }
    } else {
      localValues.current[id] = newValue;
    }
    setCounter(counter + 1);
  };
  var filterChangedWithNoCommittedValues = false;
  var isAnyDirty = false;
  var areAllEmpty = true;
  var anyFilterChanged = false;
  var currentData = getDataWithCurrentValues();
  currentData === null || currentData === void 0 ? void 0 : currentData.forEach(function (item) {
    if (item.isDirty) {
      isAnyDirty = true;
    }
    if (!item.isEmpty) {
      areAllEmpty = false;
    }
  });
  var commit = function commit() {
    var isProMultiselect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    committedValues.current = _objectSpread({}, localValues.current);
    var newData = getDataWithCurrentValues();
    var filtersChanged = isMobile && filterClear.current.clearAll ? filterClear.current.clear : isAnyDirty || filterClear.current.clear || isProMultiselect;
    anyFilterChanged = filtersChanged;
    if (onChange && !filterChangedWithNoCommittedValues && filtersChanged) {
      onChange(newData);
      filterClear.current = _objectSpread(_objectSpread({}, filterClear.current), {}, {
        id: null,
        clear: false,
        clearAll: false
      });
    }
    filterClear.current.clearAll = false;
    setCounter(counter + 1);
  };
  var filters = currentData === null || currentData === void 0 ? void 0 : currentData.map(function (item, index) {
    if (item.isDirty) {
      isAnyDirty = true;
    }
    if (!item.isEmpty) {
      areAllEmpty = false;
    }
    var selectProps = function selectProps(soft) {
      return item.type === "select" || item.type === "multiselect" ? {
        options: item.options,
        allowEmpty: true,
        value: item.value,
        onChange: function onChange(newVal) {
          return setValue(item.id, newVal, soft);
        }
      } : undefined;
    };
    var rangePickerProps = function rangePickerProps(soft) {
      return item.type === "range" ? {
        min: item.min,
        max: item.max,
        allowEmpty: item.allowEmpty,
        value: item.value,
        onChange: function onChange(newVal, isCommit) {
          setValue(item.id, newVal, !isCommit || soft);
        },
        fractionDigits: item.id === "capacity" ? 3 : 2
      } : undefined;
    };
    var clearButtonProps = function clearButtonProps(soft) {
      return {
        onClick: function onClick() {
          setValue(item.id, null, soft);
        }
      };
    };
    var commitButtonProps = function commitButtonProps() {
      return {
        onClick: function onClick() {
          commit();
        },
        disabled: !item.isDirty
      };
    };
    return _objectSpread(_objectSpread({}, item), {}, {
      selectProps: selectProps(false),
      rangePickerProps: rangePickerProps(false),
      clearButtonProps: clearButtonProps(false),
      commitButtonProps: commitButtonProps,
      soft: {
        selectProps: selectProps(true),
        rangePickerProps: rangePickerProps(true),
        clearButtonProps: clearButtonProps(true)
      }
    });
  });
  return {
    filters: filters,
    setValue: setValue,
    clearAll: function clearAll(isSoft) {
      data.forEach(function (item, index) {
        setValue(item.id, null, isSoft, false); // only last iteration should run onChange!
      });
      filterClear.current.clearAll = true;
      var committedValueToClear = filterClear.current.clear = filters.find(function (item, index) {
        return !item.isEmpty && data[index].value;
      });
      var notCommittedValuePreventClear = filters.find(function (item, index) {
        return !item.isEmpty && !data[index].value;
      });
      filterClear.current.clear = committedValueToClear && !notCommittedValuePreventClear;
    },
    commit: commit,
    isDirty: isAnyDirty,
    isEmpty: areAllEmpty,
    anyFilterChanged: anyFilterChanged
  };
}
var _default = useNormalizeAndMapFilters;
exports["default"] = _default;

/***/ }),

/***/ 94125:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _useWindowSize = _interopRequireDefault(__webpack_require__(47272));
var _useNormalizeAndMapFilters = _interopRequireDefault(__webpack_require__(68885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _RangePicker = _interopRequireDefault(__webpack_require__(22962));
var _Dialog = _interopRequireDefault(__webpack_require__(21277));
var _SelectInline = _interopRequireDefault(__webpack_require__(71070));
var _MultiSelectInline = _interopRequireDefault(__webpack_require__(35139));
var _Select = _interopRequireDefault(__webpack_require__(7222));
var _searchFilterByName = _interopRequireDefault(__webpack_require__(56630));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconArrowDown = function IconArrowDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconArrowDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  switchButtonBg: false
};
var FiltersBarDesktop = function FiltersBarDesktop(props) {
  var onChange = props.onChange,
    data = props.data,
    button = props.button,
    buttonMinimal = props.buttonMinimal,
    input = props.input,
    itemRow = props.itemRow,
    itemRowCheckmark = props.itemRowCheckmark,
    _props$switchButtonBg = props.switchButtonBg,
    switchButtonBg = _props$switchButtonBg === void 0 ? defaultProps.switchButtonBg : _props$switchButtonBg;
  var _useNormalizeAndMapFi = (0, _useNormalizeAndMapFilters["default"])({
      data: data,
      onChange: onChange
    }),
    filters = _useNormalizeAndMapFi.filters,
    commit = _useNormalizeAndMapFi.commit;
  var translations = {
    sort: (0, _langLibrary["default"])("Sort"),
    allFilters: (0, _langLibrary["default"])("all filters"),
    from: (0, _langLibrary["default"])("from range"),
    to: (0, _langLibrary["default"])("to range"),
    clear: (0, _langLibrary["default"])("Clear"),
    filter: (0, _langLibrary["default"])("Filter"),
    selected: (0, _langLibrary["default"])("selected"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list")
  };
  var buttonContainerMargins = {
    mr: "s5",
    mb: "s7"
  };
  var _useState = (0, _react.useState)(false),
    allFiltersVisible = _useState[0],
    setAllFiltersVisible = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    activeFilterOptions = _useState2[0],
    setActiveFilterOptions = _useState2[1];
  var showAllFilters = function showAllFilters(index, allFiltersVisible) {
    return !allFiltersVisible && index > 4 && setAllFiltersVisible(true);
  };
  var filterOptionsByName = function filterOptionsByName(inputValue, options, filterName) {
    var filteredOptions = (0, _searchFilterByName["default"])(inputValue, options);
    setActiveFilterOptions((0, _defineProperty2["default"])({}, filterName, filteredOptions));
  };
  var size = (0, _useWindowSize["default"])();
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      pb: "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: "wrap",
      width: "85%"
    },
    "data-test": "filters-container-desktop"
  }, filters.filter(function (filter) {
    return filter.id !== "sort";
  }).map(function (filter, index) {
    var _filter$name;
    var stringValue;
    if (filter.isCommittedEmpty) {} else if (filter.type === "multiselect") {
      showAllFilters(index, allFiltersVisible);
      if (filter.committedValue.length === 1) {
        stringValue = filter.committedValue[0].name;
      } else if (filter.committedValue.length > 1) {
        stringValue = "".concat(filter.committedValue.length, " ").concat(translations.selected);
      }
    } else if (filter.type === "range") {
      var _filter$committedValu = filter.committedValue,
        from = _filter$committedValu.from,
        to = _filter$committedValu.to;
      showAllFilters(index, allFiltersVisible);
      if (typeof from === "number" && typeof to === "number") {
        stringValue = "".concat(from, " - ").concat(to);
      } else if (typeof from === "number") {
        stringValue = "".concat(translations.from, " ").concat(from);
      } else if (typeof to === "number") {
        stringValue = "".concat(translations.to, " ").concat(to);
      }
    }
    return __jsx(_Box["default"], {
      sx: filter.isDisabled ? {
        display: "none"
      } : index >= 4 && !allFiltersVisible ? _objectSpread(_objectSpread({}, buttonContainerMargins), {}, {
        display: "none"
      }) : _objectSpread({}, buttonContainerMargins),
      key: filter.id
    }, __jsx(_Dialog["default"], {
      sx: {
        minWidth: "312px"
      },
      button: /*#__PURE__*/_react["default"].cloneElement(button, {
        sx: {
          $outline: true,
          $size: "small",
          $rounded: true,
          $selectable: filter.isCommittedEmpty,
          $switchBg: stringValue ? switchButtonBg : false
        }
      }, [translations[filter.id], stringValue ? " · " : "", stringValue]),
      root: {
        boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
        width: 300,
        bg: "white"
      },
      footer: function footer(_ref) {
        var close = _ref.close;
        return __jsx(_Box["default"], {
          sx: {
            p: "s7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopColor: "neutral",
            borderTopStyle: "solid",
            borderTopWidth: 1
          }
        }, /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
          onClick: function onClick() {
            filter.soft.clearButtonProps.onClick();
            close();
          },
          "data-test": "clear-filter"
        }, translations.clear), /*#__PURE__*/_react["default"].cloneElement(button, {
          sx: {
            $size: "small",
            $switchBg: filter.isDirty
          },
          onClick: close,
          disabled: !filter.isDirty,
          "data-test": "apply-filter"
        }, translations.filter));
      },
      onClose: function onClose() {
        setActiveFilterOptions(false);
        setTimeout(function () {
          return commit();
        }, 1);
      },
      maxHeight: size.height <= 1400 ? 300 : 500
    }, filter.type === "select" && __jsx(_SelectInline["default"], filter.soft.selectProps, itemRow), filter.type === "multiselect" && __jsx(_Box["default"], {
      sx: {
        px: "s7",
        py: "s5"
      }
    }, __jsx(_Box["default"], {
      sx: {
        mb: "s6",
        display: filter.id === "producer" || filter.id === "dajar_collection" ? "block" : "none"
      }
    }, /*#__PURE__*/_react["default"].cloneElement(input, {
      clearable: true,
      onChange: function onChange(e) {
        return filterOptionsByName(e, filter.soft.selectProps.options, filter.name, filter);
      },
      label: filter === null || filter === void 0 ? void 0 : (_filter$name = filter.name) === null || _filter$name === void 0 ? void 0 : _filter$name.toLowerCase()
    })), __jsx(_MultiSelectInline["default"], (0, _extends2["default"])({}, filter.soft.selectProps, {
      options: activeFilterOptions && activeFilterOptions[filter.name] ? activeFilterOptions[filter.name] : filter.soft.selectProps.options
    }), /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      color: "active",
      isColor: filter.id === "color_list",
      optionsArray: [],
      allVisible: true
    }))), filter.type === "range" && __jsx(_Box["default"], {
      sx: {
        p: "s7"
      }
    }, __jsx(_RangePicker["default"], (0, _extends2["default"])({}, filter.soft.rangePickerProps, {
      inputFrom: /*#__PURE__*/_react["default"].cloneElement(input, {
        label: translations.from,
        onEnter: function onEnter() {
          return commit();
        }
      }),
      inputTo: /*#__PURE__*/_react["default"].cloneElement(input, {
        label: translations.to,
        onEnter: function onEnter() {
          return commit();
        }
      }),
      separator: __jsx(_Box["default"], {
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: "s5"
        }
      }, "-")
    })))));
  }), !allFiltersVisible && filters.length > 4 && /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      $outline: true,
      $size: "small",
      $rounded: true,
      $selectable: true
    },
    onClick: function onClick() {
      return setAllFiltersVisible(!allFiltersVisible);
    }
  }, translations.allFilters)), __jsx(_Box["default"], {
    sx: {
      ml: "s6",
      pt: "s5"
    }
  }, filters.find(function (x) {
    return x.id === "sort";
  }) ? __jsx(_Select["default"], (0, _extends2["default"])({
    button: function button(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          $size: "small"
        },
        "data-test": "sorting-button",
        rightIcon: __jsx(IconArrowDown, null)
      }, value ? value.label : translations.sort);
    },
    placement: "bottomRight",
    root: {
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white",
      width: 250
    },
    selectable: itemRow
  }, filters.find(function (x) {
    return x.id === "sort";
  }).selectProps)) : null)));
};
var _default = FiltersBarDesktop;
exports.Z = _default;

/***/ }),

/***/ 97314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _useNormalizeAndMapFilters = _interopRequireDefault(__webpack_require__(68885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _RangePicker = _interopRequireDefault(__webpack_require__(84633));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _DialogUi = _interopRequireDefault(__webpack_require__(19281));
var _SelectInline = _interopRequireDefault(__webpack_require__(71070));
var _MultiSelectInline = _interopRequireDefault(__webpack_require__(35139));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _Select = _interopRequireDefault(__webpack_require__(7222));
var _searchFilterByName = _interopRequireDefault(__webpack_require__(56630));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconArrowDown = function IconArrowDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconArrowDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconClose = function IconClose(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
IconClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var FiltersBarMobile = function FiltersBarMobile(props) {
  var onChange = props.onChange,
    data = props.data,
    button = props.button,
    buttonMinimal = props.buttonMinimal,
    input = props.input,
    itemRowCheckmark = props.itemRowCheckmark,
    buttonMinimalIcon = props.buttonMinimalIcon,
    isDialogMobileOpen = props.isDialogMobileOpen;
  var _useNormalizeAndMapFi = (0, _useNormalizeAndMapFilters["default"])({
      data: data,
      onChange: onChange,
      isMobile: true
    }),
    filters = _useNormalizeAndMapFi.filters,
    commit = _useNormalizeAndMapFi.commit,
    clearAll = _useNormalizeAndMapFi.clearAll;
  var translations = {
    clear: (0, _langLibrary["default"])("Clear"),
    filter: (0, _langLibrary["default"])("Filter"),
    showResult: (0, _langLibrary["default"])("Show result"),
    sortBy: (0, _langLibrary["default"])("Sort"),
    showMore: (0, _langLibrary["default"])("show more"),
    showLess: (0, _langLibrary["default"])("show less"),
    from: (0, _langLibrary["default"])("from range"),
    to: (0, _langLibrary["default"])("to range"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list")
  };
  var MultiLineOptions = function MultiLineOptions(selectProps) {
    var _useState = (0, _react.useState)(false),
      optionsVisible = _useState[0],
      setOptionsVisible = _useState[1];
    return __jsx(_Box["default"], null, __jsx(_MultiSelectInline["default"], selectProps, /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      isColor: selectProps.isColor,
      color: "active",
      optionsArray: selectProps.options,
      allVisible: optionsVisible
    })), selectProps.options.length > 10 && __jsx(_Button["default"], {
      sx: {
        color: "main",
        font: "label",
        width: "100%",
        mt: "s8",
        textAlign: "center"
      },
      onClick: function onClick() {
        return setOptionsVisible(!optionsVisible);
      }
    }, optionsVisible ? translations.showLess : translations.showMore));
  };
  var _useState2 = (0, _react.useState)(false),
    activeFilterOptions = _useState2[0],
    setActiveFilterOptions = _useState2[1];
  var filterOptionsByName = function filterOptionsByName(inputValue, options, filterName) {
    var filteredOptions = (0, _searchFilterByName["default"])(inputValue, options);
    setActiveFilterOptions(_objectSpread(_objectSpread({}, activeFilterOptions), {}, (0, _defineProperty2["default"])({}, filterName, filteredOptions)));
  };
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      mb: "s8"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "50%",
      position: "relative"
    }
  }, __jsx(_DialogUi["default"], {
    sx: {
      height: "100%"
    },
    button: /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
      sx: {
        width: "100%",
        height: 44
      },
      leftIcon: __jsx(IconArrowDown, null)
    }, translations.filter),
    placement: "bottom",
    height: "100%",
    root: {
      bg: "white",
      top: 0
    },
    isDialogMobileOpen: isDialogMobileOpen,
    anchoredTo: "window",
    header: function header(_ref) {
      var close = _ref.close;
      return __jsx(_Box["default"], {
        sx: {
          borderBottomColor: "neutral700",
          borderBottomStyle: "solid",
          borderBottomWidth: 1
        }
      }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 50
        }
      }, /*#__PURE__*/_react["default"].cloneElement(buttonMinimalIcon, {
        sx: {
          color: "main",
          position: "relative",
          right: "12px"
        },
        onClick: function onClick() {
          setActiveFilterOptions(false);
          close();
        }
      }, __jsx(IconClose, null)), /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          font: "s_sans_underline"
        },
        onClick: function onClick() {
          clearAll(true);
          close();
        }
      }, translations.clear))));
    },
    footer: function footer(_ref2) {
      var close = _ref2.close;
      return __jsx(_Box["default"], {
        sx: {
          borderBottomColor: "neutral",
          borderBottomStyle: "solid",
          borderBottomWidth: 1
        }
      }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
        sx: {
          py: "s8"
        }
      }, /*#__PURE__*/_react["default"].cloneElement(button, {
        sx: {
          width: "100%"
        },
        onClick: close
      }, translations.showResult))));
    },
    onClose: commit
  }, __jsx(_Container["default"], {
    sx: {
      mb: "s9"
    }
  }, filters.map(function (filter, index) {
    if (filter.id === "sort") {
      return;
    }
    var createFilter = function createFilter(type) {
      var _filter$name;
      switch (type) {
        case "select":
          return __jsx(_SelectInline["default"], filter.soft.selectProps, /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
            color: "active",
            optionsArray: [],
            allVisible: true
          }));
        case "multiselect":
          return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
            sx: {
              mb: "s6",
              display: filter.id === "producer" || filter.id === "dajar_collection" ? "block" : "none"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(input, {
            clearable: true,
            onChange: function onChange(e) {
              return filterOptionsByName(e, filter.soft.selectProps.options, filter.name, filter);
            },
            label: filter === null || filter === void 0 ? void 0 : (_filter$name = filter.name) === null || _filter$name === void 0 ? void 0 : _filter$name.toLowerCase()
          })), __jsx(MultiLineOptions, (0, _extends2["default"])({}, filter.soft.selectProps, {
            isColor: filter.id === "color_list",
            options: activeFilterOptions && activeFilterOptions[filter.name] ? activeFilterOptions[filter.name] : filter.soft.selectProps.options
          })));
        case "range":
          return __jsx(_RangePicker["default"], (0, _extends2["default"])({}, filter.soft.rangePickerProps, {
            inputFrom: /*#__PURE__*/_react["default"].cloneElement(input, {
              label: translations.from
            }),
            inputTo: /*#__PURE__*/_react["default"].cloneElement(input, {
              label: translations.to
            }),
            separator: __jsx(_Box["default"], {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: "s5",
                pb: "s5"
              }
            }, "-")
          }));
      }
    };
    var headerStyles = {
      mt: "s8",
      font: "base_sans_bold",
      mb: "s7",
      color: "main",
      height: 36,
      lineHeight: "36px"
    };
    return __jsx(_Box["default"], {
      key: filter.id,
      sx: {
        borderBottomWidth: filters.length - 1 === index ? "0" : "1px",
        borderStyle: "solid",
        borderColor: "neutral700",
        pb: index < 3 ? "s8" : 0,
        display: filter.isDisabled ? "none" : "block"
      }
    }, index < 3 ? __jsx(_Box["default"], null, __jsx(_Box["default"], {
      as: "h5",
      sx: headerStyles
    }, translations[filter.id]), createFilter(filter.type)) : __jsx(_Accordion["default"], null, __jsx(_Accordion["default"].Section, {
      isOpenAtInit: index === 0
    }, __jsx(_Button["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        ":focus": {
          outline: 0,
          boxShadow: "none"
        },
        "::-moz-focus-inner": {
          border: 0
        }
      }
    }, function (_ref3) {
      var selected = _ref3.selected;
      return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
        as: "h5",
        sx: headerStyles
      }, translations[filter.id]), __jsx(_Box["default"], null, selected ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null), " "));
    }), __jsx(_ShowHide["default"], null, createFilter(filter.type), __jsx(_Box["default"], {
      sx: {
        mb: "s8"
      }
    }, " ")))));
  })))), __jsx(_Box["default"], {
    sx: {
      width: "calc(50% - 1px)",
      position: "relative",
      borderLeftWidth: "1px",
      borderStyle: "solid",
      borderColor: "neutral"
    }
  }, filters.find(function (filter) {
    return filter.id === "sort";
  }) && __jsx(_Select["default"], (0, _extends2["default"])({
    button: function button(_ref4) {
      var value = _ref4.value;
      return /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          width: "100%",
          height: 44
        },
        rightIcon: __jsx(IconArrowDown, null)
      }, value ? value.label : translations.sortBy);
    },
    anchoredTo: "window",
    placement: "bottom",
    selectable: /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      color: "active",
      rootStyles: {
        bg: "white",
        px: "5vw",
        py: "s5"
      },
      rounded: true,
      optionsArray: []
    }, translations.sortBy),
    header: __jsx(_Box["default"], {
      sx: {
        width: "100%",
        font: "base_sans_bold",
        color: "main",
        px: "5vw",
        py: "s8",
        background: "white"
      }
    }, translations.sortBy)
  }, filters.find(function (x) {
    return x.id === "sort";
  }).selectProps)))));
};
var _default = FiltersBarMobile;
exports.Z = _default;

/***/ }),

/***/ 96313:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _InputRaw = _interopRequireDefault(__webpack_require__(39789));
var _InputContainer = _interopRequireDefault(__webpack_require__(53189));
var _excluded = ["onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var isValueEmpty = function isValueEmpty(val) {
  return val === undefined || val === null || val.toString() === "";
};
var Input$ = function Input$(props) {
  var onChange = props.onChange,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(props.value),
    value = _useState[0],
    setValue = _useState[1];
  var isEmpty = isValueEmpty(value);
  var onChangeEvent = function onChangeEvent(val, e) {
    setValue(val);
    if (onChange) {
      onChange(val, e);
    }
  };
  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: isEmpty,
    onClear: function onClear() {
      onChangeEvent("", null);
    },
    label: props.label || props.placeholder,
    cursor: "text"
  }), __jsx(_InputRaw["default"], {
    sx: {
      width: "100%",
      height: "100%"
    },
    onChange: onChangeEvent,
    value: value
  }));
};
var _default = Input$;
exports.Z = _default;

/***/ }),

/***/ 22962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizeRangePickerValue = normalizeRangePickerValue;
exports.useRangePicker = useRangePicker;
exports.useRangePicker_controlled = useRangePicker_controlled;
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _excluded = ["controller"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Behaviour:
 * - RangePicker is a control, has value and onChange
 * - value is object in a form { from: [number], to: [number] }. from and to can be null if allowEmpty is true.
 * - min, max, allowEmpty - these are available behaviour flags
 * - if allowEmpty=true, then value from / to might be null.
 * - min and max are obvious, they set boundaries for range
 *
 * Incorrect values:
 * - if entire object is incorrect it's either {} or {from: [min], to:[max]} when allowEmpty is true or false respectively
 * - for "from" and "to" there are 2 types of incorrectness
 * - a) value not a number. This should be forbidden by input type=number but still. If allowEmpty=true => null, otherwise min/max
 * - b) value is a number but not in range <min;max>. Falls back always to min/max (no matter if allowEmpty=true/false).
 *
 */

function snapToMinMax(props, value) {
  var min = props.min,
    max = props.max;
  if (typeof min === "number") {
    value = Math.max(min, value);
  }
  if (typeof max === "number") {
    value = Math.min(max, value);
  }
  return value;
}
function normalizeRangePickerValue(props) {
  var keepMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var value = props.value,
    min = props.min,
    max = props.max,
    _props$allowEmpty = props.allowEmpty,
    allowEmpty = _props$allowEmpty === void 0 ? false : _props$allowEmpty,
    _props$fractionDigits = props.fractionDigits,
    fractionDigits = _props$fractionDigits === void 0 ? 0 : _props$fractionDigits;
  if (!allowEmpty && (typeof min !== "number" || typeof max !== "number")) {
    throw new Error("[RangePicker] If allowEmpty=false, you must set min and max props");
  }
  if (value === undefined || value === null) {
    return allowEmpty ? {
      from: null,
      to: null
    } : {
      from: min,
      to: max
    };
  }
  if (typeof value !== "object") {
    return allowEmpty ? {
      from: null,
      to: null
    } : {
      from: min,
      to: max
    };
  }
  var ret = {
    from: null,
    to: null
  };
  if (typeof value.from === "number" && !isNaN(value.from)) {
    ret.from = snapToMinMax(props, value.from);
  } else {
    if (!allowEmpty) {
      ret.from = min;
    }
  }
  if (typeof value.to === "number" && !isNaN(value.to)) {
    ret.to = snapToMinMax(props, value.to);
  } else {
    if (!allowEmpty) {
      ret.to = max;
    }
  }
  if (typeof ret.from === "number" && typeof ret.to === "number" && ret.from > ret.to) {
    if (keepMin) {
      if (allowEmpty) {
        ret.to = null;
      } else {
        ret.to = max;
      }
    } else {
      if (allowEmpty) {
        ret.from = null;
      } else {
        ret.from = min;
      }
    }
  }
  if (typeof ret.from === "number") {
    ret.from = parseFloat(ret.from.toFixed(fractionDigits));
  }
  if (typeof ret.to === "number") {
    ret.to = parseFloat(ret.to.toFixed(fractionDigits));
  }
  return ret;
}
function useRangePicker(props) {
  var isControlled = typeof props.value !== "undefined";
  var _useState = (0, _react.useState)(props.defaultValue),
    internalValue = _useState[0],
    setInternalValue = _useState[1];
  var controller = useRangePicker_controlled(isControlled ? props : _objectSpread(_objectSpread({}, props), {}, {
    value: internalValue,
    onChange: function onChange(newVal) {
      setInternalValue(newVal);
      if (props.onChange) {
        props.onChange(newVal);
      }
    }
  }));
  return _objectSpread(_objectSpread({}, controller), {}, {
    setValue: function setValue(newVal) {
      if (!isControlled) {
        setInternalValue(newVal);
      }
    }
  });
}
function parseValue(val) {
  if (typeof val === "string") {
    val = val.replace(/ /g, ""); // remove whitespace
    val = val.replace(/\,/g, "."); // change comma to
  }
  return parseFloat(val);
}
function useRangePicker_controlled(props) {
  var value = props.value,
    onChange = props.onChange,
    _props$onChangeTimeou = props.onChangeTimeout,
    onChangeTimeout = _props$onChangeTimeou === void 0 ? null : _props$onChangeTimeou;
  value = normalizeRangePickerValue(props, value);
  var _useState2 = (0, _react.useState)(_objectSpread(_objectSpread({}, value), {}, {
      lastEdited: "from"
    })),
    inputValue = _useState2[0],
    setInputValue = _useState2[1]; // raw input data

  var timeout = (0, _react.useRef)(null);

  // internal value is normalized value based on current inputValue (doesn't have to be commited value!)
  var internalValue = normalizeRangePickerValue(_objectSpread(_objectSpread({}, props), {}, {
    value: {
      from: parseValue(inputValue.from),
      to: parseValue(inputValue.to)
    }
  }), inputValue.lastEdited === "from");

  /**
   * If value changes in props, we should update inputs. BUT, only if value REALLY changes, which means when normalized value changed compared to local state.
   */
  (0, _react.useEffect)(function () {
    var newValueFromProps = normalizeRangePickerValue(props, inputValue.lastEdited);

    // This condition is very important. If value from props changes but after normalization it's same as current input values, we keep input values. Otherwise it would disrupt inputting UX.
    if (newValueFromProps.from === internalValue.from && newValueFromProps.to === internalValue.to) {
      return;
    }
    setInputValue(_objectSpread(_objectSpread({}, value), {}, {
      lastEdited: inputValue.lastEdited
    }));
  }, [value.from, value.to]);
  var onBlur = function onBlur() {
    setInputValue(internalValue);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      // if (value.from === internalValue.from && value.to === internalValue.to) {
      //   return;
      // }

      if (onChange) {
        onChange(internalValue, true);
      }
    }, 0);
  };
  var onFocus = function onFocus() {
    clearTimeout(timeout.current);
  };
  var change = function change(newVal, lastEdited) {
    newVal = _objectSpread(_objectSpread(_objectSpread({}, inputValue), newVal), {}, {
      lastEdited: lastEdited
    });
    setInputValue(newVal);
    if (onChange) {
      onChange(normalizeRangePickerValue(_objectSpread(_objectSpread({}, props), {}, {
        value: {
          from: parseValue(newVal.from),
          to: parseValue(newVal.to)
        }
      }), lastEdited), false);
    }
  };
  var inputFromProps = {
    value: inputValue.from === null || inputValue.from === undefined ? "" : inputValue.from.toString(),
    onChange: function onChange(newVal) {
      change({
        from: newVal
      }, "from");
    },
    onBlur: onBlur,
    onFocus: onFocus,
    label: "From",
    type: "text",
    inputmode: "numeric"
  };
  var inputToProps = {
    value: inputValue.to === null || inputValue.to === undefined ? "" : inputValue.to.toString(),
    onChange: function onChange(newVal) {
      change({
        to: newVal
      }, "to");
    },
    onBlur: onBlur,
    onFocus: onFocus,
    label: "To",
    type: "text",
    inputmode: "numeric"
  };
  return {
    inputFromProps: inputFromProps,
    inputToProps: inputToProps,
    value: internalValue,
    commit: onBlur
  };
}

/**
 * NOTES:
 *
 * 1. We should work on accessibility, labels, fieldset, etc. We should think if there shouldn't be form.
 * 2. We should add clear button.
 * 3. Basic layout (input, separator, input, potentially clear button on the left / right handside) is just basic. We should allow for render props to do ANY layout out of those elements.
 * 4. Timeout / ENTER on submit.
 * 5. Think of mobile users. What happens when someone wants to hide the keyboard, or submits. Keyboard should hide and calculations should take place!
 * 6. We should have onChange and onCommit events. onCommit doesn't run when someone is editing the price (to prevent unnecessary reloads etc). onCommit can run after timeout of user being idle. OR on ENTER. OR on keyboard submit on mobile.
 */
function RangePicker(_ref) {
  var controller = _ref.controller,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!controller) {
    controller = useRangePicker(props);
  }
  var inputFrom = props.inputFrom,
    inputTo = props.inputTo,
    separator = props.separator;
  if (/*#__PURE__*/_react["default"].isValidElement(separator)) {} else if (typeof separator === "object") {
    separator = __jsx(_Box["default"], {
      sx: _objectSpread({}, separator)
    });
  }
  inputFrom = /*#__PURE__*/_react["default"].cloneElement(inputFrom, _objectSpread(_objectSpread({}, controller.inputFromProps), {}, {
    label: inputFrom.props && inputFrom.props.label
  }));
  inputTo = /*#__PURE__*/_react["default"].cloneElement(inputTo, _objectSpread(_objectSpread({}, controller.inputToProps), {}, {
    label: inputTo.props && inputTo.props.label
  }));
  return __jsx(_Box["default"], {
    as: "form",
    sx: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      controller.commit();
    }
  }, __jsx(_Box["default"], {
    sx: {
      flex: "1 1 auto"
    }
  }, inputFrom), separator && __jsx(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, separator), __jsx(_Box["default"], {
    sx: {
      flex: "1 1 auto"
    }
  }, inputTo), __jsx("button", {
    type: "submit",
    hidden: true
  }));
}
var _default = RangePicker;
exports["default"] = _default;

/***/ }),

/***/ 11604:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var RectangleCardWithLabelBoxInside = function RectangleCardWithLabelBoxInside(props) {
  var link = props.link,
    label = props.label,
    image = props.image,
    promoLabel = props.promoLabel;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(Link, {
    route: link
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, __jsx(_Image["default"], {
    sx: {
      width: "100%",
      height: "100%",
      position: "relative",
      zIndex: 1,
      objectFit: "contain",
      aspectRatio: 1.333
    },
    sizes: "(max-width: 1300px) and (min-width: 1200px) 210px, 420px",
    image: image
  }, __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      bottom: "s8",
      width: "100%",
      textAlign: "center",
      zIndex: 2
    }
  }, label && __jsx(_Box["default"], {
    sx: {
      display: "inline-block",
      bg: "white",
      pt: "s4",
      pb: "s2",
      px: "s6",
      font: "label2",
      maxWidth: "80%",
      color: "main",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: promoLabel === null || promoLabel === void 0 ? void 0 : promoLabel.labelColor
    },
    as: "span"
  }, promoLabel === null || promoLabel === void 0 ? void 0 : promoLabel.labelText, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      bg: "main",
      width: "2px",
      height: "2px",
      display: promoLabel !== null && promoLabel !== void 0 && promoLabel.labelText ? "inline-block" : "none",
      mx: "s3",
      bottom: "s3"
    },
    as: "i"
  })), label)))));
};
var _default = RectangleCardWithLabelBoxInside;
exports.Z = _default;

/***/ }),

/***/ 32058:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ButtonText = _interopRequireDefault(__webpack_require__(27210));
var _core = __webpack_require__(79329);
var _ButtonMinimalIcon = _interopRequireDefault(__webpack_require__(95574));
var __jsx = _react["default"].createElement;
// const heights = {
//   small: "36px",
//   standard: "48px",
//   large: "58px"
// };

var fonts = {
  small: "body2",
  standard: "base_sans",
  large: "base_sans",
  upper: "xs_caps"
};
var _default = (0, _core.createComponent)(_ButtonText["default"], function (_ref) {
  var _ref$$size = _ref.$size,
    $size = _ref$$size === void 0 ? "standard" : _ref$$size,
    _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color,
    _ref$$smallIcon = _ref.$smallIcon,
    $smallIcon = _ref$$smallIcon === void 0 ? false : _ref$$smallIcon;
  return {
    // height: heights[$size],
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    },
    svg: {
      display: "block"
    },
    lineHeight: 1,
    $body: function $body(_ref2) {
      var isHovered = _ref2.isHovered;
      return {
        color: $color,
        font: fonts[$size],
        opacity: isHovered ? 0.8 : 1,
        lineHeight: 1
      };
    },
    $gap: $smallIcon ? "10px" : "4px",
    $iconSize: $smallIcon ? 16 : 24,
    $loader: {
      __children: __jsx(_ButtonMinimalIcon["default"], {
        sx: {
          $color: $color,
          $color2: "rgba(255,255,255,0.2)"
        }
      })
    }
  };
});
exports["default"] = _default;

/***/ }),

/***/ 30136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Checkmark = _interopRequireDefault(__webpack_require__(22040));
var _excluded = ["color"];
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  color: "main"
};
var Checkmark = function Checkmark(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? defaultProps.color : _props$color,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_Checkmark["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled,
        invalid = _ref.invalid;
      return _objectSpread({
        bg: disabled ? "neutral100" : selected ? color : "white",
        transition: "all .1s",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: invalid ? "negative" : selected ? "transparent" : "neutral900",
        borderRadius: props.rounded ? 50 : 4,
        $icon: {
          color: disabled ? "neutral900" : "white"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkmark;
exports["default"] = _default;

/***/ }),

/***/ 37710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Selectable = _interopRequireDefault(__webpack_require__(53910));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Checkmark = _interopRequireDefault(__webpack_require__(30136));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ItemRowCheckmark = function ItemRowCheckmark(props) {
  return __jsx(_Selectable["default"], props, function (_ref) {
    var disabled = _ref.disabled,
      highlighted = _ref.highlighted,
      selected = _ref.selected,
      label = _ref.label,
      optionsArray = _ref.optionsArray,
      allVisible = _ref.allVisible,
      option = _ref.option,
      _ref$isColor = _ref.isColor,
      isColor = _ref$isColor === void 0 ? false : _ref$isColor;
    var optionIndex = optionsArray.map(function (option) {
      return option.label;
    }).indexOf(label);
    return __jsx(_Box["default"], {
      sx: _objectSpread({
        width: "100%",
        minWidth: "250px",
        display: optionIndex > 9 ? allVisible ? "flex" : "none" : "flex",
        py: "s5",
        alignItems: "center",
        font: "body2",
        opacity: disabled ? 0.5 : 1,
        justifyContent: "space-between"
      }, props.rootStyles)
    }, __jsx(_Box["default"], {
      sx: {
        color: selected ? "active" : "main"
      }
    }, label, " ", (option === null || option === void 0 ? void 0 : option.amount) && !isColor && "(".concat(option === null || option === void 0 ? void 0 : option.amount, ")")), __jsx(_Checkmark["default"], props));
  });
};
var _default = ItemRowCheckmark;
exports.Z = _default;

/***/ }),

/***/ 56630:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchFilterByName = function searchFilterByName(inputValue, options) {
  var filteredOptions = [];
  options.map(function (option) {
    if (option.name.toLowerCase().includes(inputValue.toLowerCase())) {
      filteredOptions.push(option);
    }
  });
  return filteredOptions;
};
var _default = searchFilterByName;
exports["default"] = _default;

/***/ }),

/***/ 17930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_FiltersBarDesktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94125);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51586);
/* harmony import */ var _deosite_components_new_buttons_ButtonMinimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32058);
/* harmony import */ var _formControls_input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37003);
/* harmony import */ var _selectables_ItemRow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93193);
/* harmony import */ var _selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86282);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FiltersBarDesktop = function(props) {
    var propsExt = _objectSpread({}, props, {
        button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
        buttonMinimal: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimal__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
        input: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_formControls_input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
        itemRow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_selectables_ItemRow__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
        itemRowCheckmark: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_FiltersBarDesktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (FiltersBarDesktop);


/***/ }),

/***/ 34801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_FiltersBarMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97314);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51586);
/* harmony import */ var _deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95574);
/* harmony import */ var _deosite_components_new_buttons_ButtonMinimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32058);
/* harmony import */ var _formControls_input_Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37003);
/* harmony import */ var _selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86282);
/* harmony import */ var _selectables_ItemRow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93193);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FiltersBarMobile = function(props) {
    var propsExt = _objectSpread({}, props, {
        button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
        buttonMinimal: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimal__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
        input: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_formControls_input_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
        itemRow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_selectables_ItemRow__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
        itemRowCheckmark: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
        buttonMinimalIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_4__["default"], {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_FiltersBarMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (FiltersBarMobile);


/***/ }),

/***/ 62999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11604);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RectangleCardWithLabelBoxInside = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (RectangleCardWithLabelBoxInside);


/***/ }),

/***/ 37003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ input_Input; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../components-new/dist/Input/index.js
var Input = __webpack_require__(96313);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/index.js
var core2 = __webpack_require__(79329);
// EXTERNAL MODULE: ./src/icons/close.svg
var icons_close = __webpack_require__(46565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
;// CONCATENATED MODULE: ./src/icons/keyboard_arrow_down.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgKeyboardArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  })));
}
/* harmony default export */ var keyboard_arrow_down = (SvgKeyboardArrowDown);
;// CONCATENATED MODULE: ./src/components/formControls/form-styles.js



var formStyles = {
    $root: function(param) {
        var focused = param.focused, disabled = param.disabled, invalid = param.invalid;
        return {
            height: "48px",
            border: "1px solid",
            borderColor: disabled ? "main" : invalid ? "negative" : focused ? "main" : "neutral700",
            bg: disabled ? "transparent" : "transparent",
            borderRadius: "4px"
        };
    },
    $control: function(param) {
        var empty = param.empty;
        return {
            font: "base_sans",
            lineHeight: 1,
            pt: empty ? 0 : "14px",
            pr: "10px",
            pl: "10px",
            transition: "padding .2s ease-out",
            color: empty ? "neutral900" : "main"
        };
    },
    $leftEnhancersContainer: {
        $gutter: "8px",
        pl: "16px"
    },
    $rightEnhancersContainer: {
        $gutter: "8px",
        pr: "16px"
    },
    $arrow: function(param) {
        var empty = param.empty;
        return {
            pr: "10px",
            color: empty ? "neutral900" : "main",
            lineHeight: 1,
            svg: {
                display: "block"
            },
            __children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyboard_arrow_down, {})
        };
    },
    $label: function(param) {
        var empty = param.empty, invalid = param.invalid;
        return {
            top: "50%",
            left: "10px",
            transform: empty ? "translateY(-12px)" : "translateY(-15px)",
            opacity: empty ? 0 : 1,
            transition: "all .2s ease-out",
            font: "xxs_caps",
            textTransform: "normal",
            color: invalid ? "negative" : "neutral700"
        };
    },
    $labelInside: true
};
/* harmony default export */ var form_styles = (formStyles);

;// CONCATENATED MODULE: ./src/components/formControls/input/Input.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Input_Input = (0,core2.createComponent)(Input/* default */.Z, _objectSpread({}, form_styles, {
    $clearElement: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {
        style: {
            display: "block"
        }
    }),
    $rightEnhancersContainer: function(param) {
        var invalid = param.invalid;
        return {
            $gutter: "8px",
            pr: 10,
            display: invalid ? "static" : "none",
            fill: invalid ? "negative" : "main"
        };
    }
}));
Input_Input.labelInside = true;
/* harmony default export */ var input_Input = (Input_Input);


/***/ }),

/***/ 93193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_selectables_ItemRow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(627);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ItemRow = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_selectables_ItemRow__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemRow);


/***/ }),

/***/ 86282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37710);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ItemRowCheckmark = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_selectables_ItemRowCheckmark__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemRowCheckmark);


/***/ })

}]);